import { Button, useLatestMovements } from '@itarget/shared'
import { Box, Typography } from '@material-ui/core'
import { useContext } from 'react'
import { FidelityContext } from '../../../context/FidelityContext'
import Loading from '../../Loading'
import NoData from '../../NoData'
import Transaction from '../../Transaction'
import { useLatestMovementsStyles } from './styles'
import { useLatestMovementsTranslation } from './translation'

export const LatestMovements = () => {
  const latestMovementsClasses = useLatestMovementsStyles()
  const latestMovementsTranslation = useLatestMovementsTranslation()
  const { getLatestMovements, isLatestMovementsLoaded } = useLatestMovements()
  const { tabsEnums, handleChangeTab } = useContext(FidelityContext)
  const handleSeeMoreTransactions = () => {
    handleChangeTab(tabsEnums.STATEMENT)
  }
  const latestMovements = getLatestMovements()
  const isEmpty = latestMovements.length === 0

  return (
    <Box className={latestMovementsClasses.root}>
      <Box className={latestMovementsClasses.header}>
        <Typography className={latestMovementsClasses.title}>
          {latestMovementsTranslation.latestMovements}
        </Typography>

        <Button
          variant="text"
          onClick={handleSeeMoreTransactions}
          className={latestMovementsClasses.seeMore}
        >
          {latestMovementsTranslation.seeExtract}
        </Button>
      </Box>

      <Box className={latestMovementsClasses.listContainer}>
        {!isLatestMovementsLoaded && <Loading />}
        {isLatestMovementsLoaded && isEmpty && <NoData />}
        {isLatestMovementsLoaded &&
          !isEmpty &&
          latestMovements.map(
            (
              {
                status,
                points,
                modality,
                description,
                transactionDate,
                transactionType,
              },
              key,
            ) => (
              <Transaction
                status={status}
                points={points}
                modality={modality}
                canUsePrivacy={true}
                description={description}
                transactionDate={transactionDate}
                transactionType={transactionType}
                key={`movement-component-${key}`}
              />
            ),
          )}
      </Box>
    </Box>
  )
}
